<template>
  <div class="container">
    <div class="ui left aligned grid">
      <h1>{{ title }} Company Discount</h1>
    </div>

    <div class="ui divider"></div>

    <form class="ui form row segment" @submit.prevent="companyDiscountUpdate">
      <div class="ui grid stackable">
        <div class="row">
          <div class="eight wide column">
            <label>Company</label>
            <div class="ui fluid search selection dropdown" id="CompanySelect">
              <input
                type="hidden"
                name="company"
                v-model="companyId"
                id="company"
                @change="onCompanyChange($event.target.value)"
              />
              <div class="default text">Company</div>
              <i class="dropdown icon"></i>
              <div class="menu">
                <div
                  class="item"
                  v-for="company in companies"
                  v-bind:data-value="company.value"
                  :key="company.value"
                >
                  {{ company.text }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="eight wide column">
            <label>Machine</label>
            <div class="ui fluid search selection dropdown" id="MachineSelect">
              <input
                type="hidden"
                name="Machine"
                v-model="machineId"
                required
                id="Machine"
                @change="onMachineChange"
              />
              <div class="default text">Select Machine</div>
              <i class="dropdown icon"></i>
              <div class="menu">
                <div
                  class="item"
                  v-for="machine in machines"
                  :key="machine.id"
                  v-bind:data-value="machine.value"
                >
                  {{ machine.text }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row" v-if="machineId">
          <div class="eight wide column">
            <label>Assembly</label>
            <div class="ui fluid search selection dropdown" id="AssemblySelect">
              <input
                type="hidden"
                name="Assembly"
                v-model="assemblyId"
                required
                id="Assembly"
                @change="onAssemblyChange"
              />
              <div class="default text">Select Assembly</div>
              <i class="dropdown icon"></i>
              <div class="menu">
                <div
                  class="item"
                  v-for="assembly in assemblies"
                  :key="assembly.id"
                  v-bind:data-value="assembly.value"
                >
                  {{ assembly.text }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-if="assemblyId">
          <div class="eight wide column">
            <label>Sub-Assembly</label>
            <div
              class="ui fluid search selection dropdown"
              id="SubAssemblySelect"
            >
              <input
                type="hidden"
                name="Subassembly"
                v-model="subAssemblyId"
                required
                id="Subassembly"
                @change="onSubAssemblyChange"
              />
              <div class="default text">Select Sub-Assembly</div>
              <i class="remove icon"></i>
              <i class="dropdown icon"></i>
              <div class="menu">
                <div
                  class="item"
                  v-for="assembly in subAssemblies"
                  :key="assembly.id"
                  v-bind:data-value="assembly.value"
                >
                  {{ assembly.text }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-if="subAssemblyId">
          <div class="eight wide column">
            <label>Part</label>
            <div class="ui fluid search selection dropdown" id="partsSelect">
              <input
                type="hidden"
                name="part"
                v-model="partId"
                id="part"
                @change="onPartChange"
              />
              <div class="default text">Part</div>
              <i class="dropdown icon"></i>
              <div class="menu">
                <div
                  class="item"
                  v-for="part in parts"
                  v-bind:data-value="part.value"
                  :key="part.value"
                >
                  {{ part.text }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="eight wide column">
            <label>Discount</label>
            <input
              name="Discount %"
              placeholder="Discount"
              class="field"
              :value="discount"
              @input="updateValue"
            />
          </div>
        </div>

        <div class="row">
          <div class="eight wide column">
            <label for="active" class="toggle label">Inactive</label>
            <div class="ui toggle checkbox">
              <input
                id="active"
                name="active"
                type="checkbox"
                tabindex="0"
                class
                v-model="active"
              />
              <label for="active">Active</label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="eight wide column">
            <div class="ui buttons">
              <button class="ui positive button">{{ button }} Discount</button>
              <div class="or"></div>
              <div class="ui light button" @click="$router.go(-1)">Cancel</div>
            </div>
          </div>

          <div class="eight wide column" v-if="$route.params.id">
            <div class="ui primary button right floated" @click="deleteModal">
              Delete Discount
            </div>
          </div>
        </div>
      </div>
    </form>
    <semantic-modal medium flip vertical :active.sync="showModal">
      <i class="close icon"></i>
      <div class="header">Are you sure you want to delete this discount?</div>
      <div class="actions">
        <div class="ui black deny button" @click="showModal = false">Nope</div>
        <div
          class="ui positive right labeled icon button"
          @click="companyDiscountDelete($route.params.id)"
        >
          Yes
          <i class="checkmark icon"></i>
        </div>
      </div>
    </semantic-modal>
  </div>
</template>

<script>
import APIService from "@/assets/js/APIService";
const apiService = new APIService();

import SemanticModal from "vue-ya-semantic-modal";
import "semantic-ui-dropdown/dropdown.js";

export default {
  name: "ManageCompanyDiscountDetails",
  computed: {},
  components: {
    SemanticModal: SemanticModal(),
  },
  mounted() {
    $(".ui.dropdown").dropdown({
      fullTextSearch: true,
      sortSelect: true,
      match: "text",
    });

    if (this.$route.params.id == undefined) {
      this.getCompanies();

      $(".ui.dropdown .remove.icon").on("click", function(e) {
        $(this)
          .parent(".dropdown")
          .dropdown("clear");
        e.stopPropagation();
      });

      this.button = "Add";
      this.title = "Add";
    } else {
      this.companyDiscountDetails();
      this.button = "Save";
      this.title = "Edit";
    }
  },
  data() {
    return {
      showModal: false,
      companyId: "",
      company: "",
      companies: [],
      machines: [],
      machineId: "",
      assemblies: [],
      assemblyId: "",
      subAssemblies: [],
      subAssemblyId: "",
      partId: "",
      parts: [],
      active: true,
      error: "",
      button: "",
      title: "",
      discount: null,
    };
  },
  methods: {
    deleteModal() {
      this.showModal = !this.showModal;
    },
    onPartChange(event) {
      this.partId = event.target.value;
    },
    updateValue() {
      const value = event.target.value;
      if (!isNaN(value) && value <= 100) {
        const chars = String(value).split(".");
        this.discount = `${chars[0]}`;
        if (chars[1] || value.includes(".")) {
          this.discount = `${this.discount}.${chars[1].slice(0, 2)}`;
        }
      }
      this.$forceUpdate();
    },
    getCompanies() {
      $("#CompanySelect").dropdown("clear");
      apiService
        .getCompaniesList()
        .then((data) => {
          this.companies = data;
        })
        .then(() => {
          $("#CompanySelect").dropdown({
            fullTextSearch: true,
            sortSelect: true,
            match: "text",
          });
        });
    },
    companyDiscountDetails() {
      apiService
        .getCompanyDiscountDetails(this.$route.params.id)
        .then((request) => {
          this.companyDiscountSuccessful(request);
          let _this = this;
          setTimeout(function() {
            $("#CompanySelect").dropdown("set selected", _this.companyId);
            $("#MachineSelect").dropdown("set selected", _this.machineId);
            $("#AssemblySelect").dropdown("set selected", _this.assemblyId);
            $("#SubAssemblySelect").dropdown(
              "set selected",
              _this.subAssemblyId
            );
            $("#PartsSelect").dropdown("set selected", _this.partId);
          }, 2000);

          this.getCompanies();
          this.getMachineSelectedItems();
          this.getAssemblyList();
          this.getSubAssemblySelectedItems();
          this.getPartsSelectedItems();
        })
        .catch((err) => this.companyDiscountFailed(err));
    },
    companyDiscountSuccessful(request) {
      this.companyId = request.companyId;
      this.partId = request.partId;
      this.machineId = request.machineId;
      this.assemblyId = request.assemblyId;
      this.subAssemblyId = request.subAssemblyId;
      this.discount = request.discount;
      this.active = request.active;
    },
    companyDiscountFailed(err) {
      console.log(err)
      this.$bvToast.toast("TraceID: " + err.error.response.data.traceId, {
        title: err.error.response.data.title,
        autoHideDelay: 10000,
        appendToast: false,
        variant: "danger",
        solid: true,
      });
    },
    onCompanyChange(e) {
      this.companyId = e;
      this.machines = [];
      this.machineId = "";
      this.assemblies = [];
      this.assemblyId = "";
      this.subAssemblies = [];
      this.subAssemblyId = "";
      this.parts = [];
      this.partId = "";
      this.getMachineSelectedItems();
    },
    onMachineChange(event) {
      this.machineId = event.target.value;
      this.assemblies = [];
      this.assemblyId = "";
      this.subAssemblies = [];
      this.subAssemblyId = "";
      this.parts = [];
      this.partId = "";
      this.getAssemblyList();
    },
    onAssemblyChange(event) {
      this.assemblyId = event.target.value;
      this.subAssemblies = [];
      this.subAssemblyId = "";
      this.parts = [];
      this.partId = "";
      this.getSubAssemblySelectedItems();
    },
    onSubAssemblyChange(event) {
      this.subAssemblyId = event.target.value;
      this.getPartsSelectedItems();
    },
    getMachineSelectedItems() {
      $("#MachineSelect").dropdown("clear");
      let _this = this;
      apiService
        .getMachinesByCompany({
          id: _this.companyId,
        })
        .then((data) => {
          this.machines = data;
        })
        .then(() => {
          $("#MachineSelect").dropdown({
            fullTextSearch: true,
            sortSelect: true,
            match: "text",
          });
        });
      // .then(() => {
      //   if (_this.assemblyId) {
      //   }
      // });
    },
    getAssemblyList() {
      $("#AssemblySelect").dropdown("clear");
      // let _this = this;
      apiService
        .getSelectItemsByCompanyMachine({
          id: this.machineId,
          showAll: true,
        })
        .then((data) => {
          this.assemblies = data;
        })
        .then(() => {
          $("#AssemblySelect").dropdown({
            fullTextSearch: true,
            sortSelect: true,
            match: "text",
          });
        });
      // .then(() => {
      //   if (_this.subAssemblyId) {
      //   }
      // });
    },
    getSubAssemblySelectedItems() {
      if (this.assemblyId) {
        $("#SubAssemblySelect").dropdown("clear");
        apiService
          .getSubAssemblyList({
            id: this.assemblyId,
          })
          .then((data) => {
            this.subAssemblies = data;
          })
          .then(() => {
            $("#SubAssemblySelect").dropdown({
              fullTextSearch: true,
              sortSelect: true,
              match: "text",
            });
          });
      }
    },
    async getPartsSelectedItems() {
      if (this.subAssemblyId) {
        $("#partsSelect").dropdown("clear");
        apiService
          .getCompanyPartsList(
            this.companyId,
            this.$route.params.id || 0,
            this.subAssemblyId
          )
          .then((data) => {
            this.parts = data;
          })
          .then(() => {
            $("#partsSelect").dropdown({
              fullTextSearch: true,
              sortSelect: true,
              match: "text",
            });
          });
      }
    },
    companyDiscountDelete() {
      apiService
        .deleteCompanyDiscount(this.$route.params.id)
        .then((request) => {
          this.companyDiscountSuccessful(request);
          this.showModal = !this.showModal;
          this.$router.push("/admin/company/discounts");
        })
        .catch((err) => this.companyDiscountFailed(err));
    },
    companyDiscountUpdate() {
      if (!this.companyId) {
        this.$bvToast.toast("Please select a company", {
          title: "Missing field(s)",
          autoHideDelay: 3000,
          appendToast: false,
          variant: "danger",
          solid: true,
        });
      } else if (!this.assemblyId) {
        this.$bvToast.toast("Please select a assembly", {
          title: "Missing field(s)",
          autoHideDelay: 3000,
          appendToast: false,
          variant: "danger",
          solid: true,
        });
      } else if (!this.subAssemblyId) {
        this.$bvToast.toast("Please select a subassembly", {
          title: "Missing field(s)",
          autoHideDelay: 3000,
          appendToast: false,
          variant: "danger",
          solid: true,
        });
      } else if (!this.partId) {
        this.$bvToast.toast("Please select a part", {
          title: "Missing field(s)",
          autoHideDelay: 3000,
          appendToast: false,
          variant: "danger",
          solid: true,
        });
      } else if (!this.discount) {
        this.$bvToast.toast("Please enter a discount", {
          title: "Missing field(s)",
          autoHideDelay: 3000,
          appendToast: false,
          variant: "danger",
          solid: true,
        });
      }
      if (this.companyId && this.partId && this.discount) {
        if (this.$route.params.id == undefined) {
          apiService
            .createCompanyDiscount({
              companyId: this.companyId,
              partId: this.partId,
              machineId: this.machineId,
              assemblyId: this.subAssemblyId,
              discount: this.discount,
              active: this.active,
            })
            .then((request) => {
              this.companyDiscountSuccessful(request);
              this.$router.push("/admin/company/discounts");
            })
            .catch((err) => this.companyDiscountFailed(err));
        } else {
          apiService
            .updateCompanyDiscount(this.$route.params.id, {
              companyId: this.companyId,
              partId: this.partId,
              machineId: this.machineId,
              assemblyId: this.subAssemblyId,
              discount: this.discount,
              active: this.active,
            })
            .then((request) => {
              this.companyDiscountSuccessful(request);
              this.$router.push("/admin/company/discounts");
            })
            .catch((err) => this.companyDiscountFailed(err));
        }
      }
    },
    addCompanies(addedValue) {
      this.companies.push(addedValue);
    },
    removeCompanies(removedValue) {
      removedValue = parseInt(removedValue);

      var index = this.companies.indexOf(removedValue);

      if (index > -1) {
        this.companies.splice(index, 1);
      }
    },
  },
};
</script>
